'use client';
import Contentlet from '@/components/shared/contentlet';
import VideoHeader from './VideoHeader';
import VideoCard from '@/components/videos/VideoCard';
import { DotBlockEditor } from '@/components/shared/decodeTextBlock';
import TagList from '@/components/shared/TagList';

const TAG_COLORS = ['bg-custom-ghost', 'bg-custom-veil', 'bg-custom-frost'];

function DetailPage({ video, relatedVideos, maxLimit = 4 }) {
    const hasRelatedVideos =
        relatedVideos && Array.isArray(relatedVideos) && relatedVideos.length > 0;
    const limitedRelated = hasRelatedVideos ? relatedVideos.slice(0, maxLimit) : [];

    const tags =
        video.tags
            ?.split(',')
            .map((tag, i) => ({
                text: tag.trim(),
                fontColor: 'text-white',
                bgColor: TAG_COLORS[i]
            }))
            .slice(0, 3) ?? [];

    return (
        <main className="flex w-full flex-col">
            <div className="px-5 py-14">
                <Contentlet contentlet={video}>
                    <div className="container flex max-w-7xl flex-col gap-6 p-0">
                        <div className="flex flex-col gap-1">
                            {!!tags.length && <TagList tags={tags} />}
                            <h1 className="text-4xl font-bold text-white lg:text-5xl">
                                {video.title}
                            </h1>
                        </div>

                        {/* Video + metadata bar */}
                        <VideoHeader video={video} />

                        {/* Description + related videos (YouTube-style) */}
                        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_400px]">
                            {/* Description */}
                            <article className="prose w-full max-w-fit">
                                <DotBlockEditor blocks={video.description} />
                            </article>

                            {/* Related videos sidebar */}
                            {hasRelatedVideos && (
                                <aside className="flex flex-col gap-4">
                                    <h4 className="text-white">Related Videos</h4>
                                    <div className="flex flex-col gap-6">
                                        {limitedRelated.map((contentlet, i) => (
                                            <VideoCard
                                                key={contentlet.identifier || i}
                                                contentlet={contentlet}
                                            />
                                        ))}
                                    </div>
                                </aside>
                            )}
                        </div>
                    </div>
                </Contentlet>
            </div>
        </main>
    );
}

export default DetailPage;
